(function () {
  if (window.imCouponCopyReady) return;
  window.imCouponCopyReady = true;

  function legacyCopy(text) {
    // Works where the async Clipboard API is unavailable, blocked, or the
    // document has lost focus (older Safari, non-secure contexts, embeds).
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.top = '-1000px';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    field.setSelectionRange(0, text.length);

    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (_error) {
      copied = false;
    }

    document.body.removeChild(field);
    return copied;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        return legacyCopy(text) ? Promise.resolve() : Promise.reject();
      });
    }

    return legacyCopy(text) ? Promise.resolve() : Promise.reject();
  }

  function flash(group, chip, message) {
    if (chip) {
      chip.classList.add('is-copied');
      clearTimeout(chip.imCopyTimer);
      chip.imCopyTimer = setTimeout(function () {
        chip.classList.remove('is-copied');
      }, 2000);
    }

    if (!group) return;
    var feedback = group.querySelector('[data-coupon-feedback]');
    if (!feedback) return;

    feedback.textContent = message;
    clearTimeout(group.imFeedbackTimer);
    group.imFeedbackTimer = setTimeout(function () {
      feedback.textContent = '';
    }, 2600);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-coupon-copy]');
    if (!trigger) return;

    event.preventDefault();

    var code = trigger.getAttribute('data-coupon-copy');
    if (!code) return;

    var group = trigger.closest('.coupon-code');
    var chip = group ? group.querySelector('[data-coupon-copy="' + code.replace(/"/g, '\\"') + '"].coupon-code__chip') : null;

    copyText(code).then(
      function () {
        flash(group, chip, code + ' copied to clipboard');
      },
      function () {
        flash(group, null, 'Copy failed — your code is ' + code);
      }
    );
  });
})();
